import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/Home";
import LoginPage from "./pages/Login";
import { UserProvider } from "./contexts/UserContext";
import ThemesPage from "./pages/Themes";
import StartProjectPage from "./pages/StartProject";
import Portfolio from "./pages/Portfolio";

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/themes" element={<ThemesPage />} />
          <Route path="/get-started" element={<StartProjectPage />} />
          <Route path="/portfolio" element={<Portfolio />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
